import "./assets/css/style.css";
import "./assets/css/responsive.css";
import { RouterProvider } from "react-router-dom";
import router from "./routes/router.config";

function App() {
  // const ScrollToTop = () => {
  //   const { pathname } = useLocation();

  //   useLayoutEffect(() => {
  //     document.documentElement.scrollTo({
  //       top: 0,
  //       left: 0,
  //       behavior: "instant",
  //     });
  //   }, [pathname]);

  //   return null;
  // };
  return (
    <>
      <RouterProvider router={router} />
    </>
  );
  // return (
  //   <main>
  //     <Router>
  //       {/* <ScrollToTop /> */}
  //       <Navbar />
  //       <Routes>
  //         {routes.map((route, index) => (
  //           <Route key={index} path={route.path} element={route.element}>
  //             {route.children?.map((child, idx) => (
  //               <Route key={idx} path={child.path} element={child.element} />
  //             ))}
  //           </Route>
  //         ))}
  //       </Routes>
  //       <Footer />
  //     </Router>
  //   </main>
  // );
}

export default App;
